import logoUrl from '../../assets/images/Senerfi-formato.png';
import { getQualityPrintMeta } from './qualityPrintConfig';

export async function printMovement(mv) {
  try {
    const qualityMeta = await getQualityPrintMeta('movement');
    const type = String(mv?.type || '').trim();
    const isConsumible = type.toLowerCase().includes('consumible');
    const isSalida = type.startsWith('Salida') && !isConsumible;
    const isEntrada = type.startsWith('Entrada');
    const isAsignacion = type === 'Asignación';
    const isPrestamo = type === 'Préstamo' || type === 'Prestamo';
    const isDevolucion = type === 'Devolución';
    const isTraslado = type.startsWith('Traslado');

    const warehouseName = (id) => {
      if (!id) return '';
      if (id === 'popayan') return 'Popayán';
      if (id === 'santander') return 'Santander de Quilichao';
      return id;
    };

    const proyecto = warehouseName(mv?.warehouseId) || (isSalida ? 'Almacén' : '');
    const proyectoLinea2 = mv?.projectCode || mv?.projectId || mv?.projectNumber || mv?.projectRef || '';
    const entryRef = mv?.entryRef || mv?.entry_ref || '';
    const formatRef = (function(){
      const preset = String(mv?.formatRef || entryRef || '').trim();
      if (preset) return preset;
      const t = new Date().toISOString().replace(/[-:.TZ]/g,'').slice(0,14);
      const p = isAsignacion ? 'ASG' : isEntrada ? 'ENT' : isConsumible ? 'CON' : isPrestamo ? 'PRE' : isSalida ? 'SAL' : isDevolucion ? 'DEV' : isTraslado ? 'TRA' : 'FMT';
      const r = String(Math.floor(Math.random()*10000)).padStart(4,'0');
      return `${p}-${t}-${r}`;
    })();

    // Resolver datos del responsable (quien recibe en asignación, quien entrega en devolución)
    let responsibleName = mv?.responsibleName || '';
    let responsibleDoc = mv?.responsibleDoc || '';
    let responsibleCargo = mv?.responsibleRole || mv?.cargo || '';

    // Si el "nombre" viene con la cédula (solo números), pásalo a responsibleDoc
    if (!responsibleDoc) {
      const trimmed = String(responsibleName || '').trim();
      if (/^\d{6,}$/.test(trimmed)) {
        responsibleDoc = trimmed;
        responsibleName = '';
      }
    }
    // Si el nombre es igual a la cédula, limpiarlo para buscar el real
    if (String(responsibleName).trim() === String(responsibleDoc).trim()) {
      responsibleName = '';
    }

    try {
      const doc = String(responsibleDoc || '').trim();
      if (doc) {
        // 1. Buscar en senerfi_people
        const peopleRaw = localStorage.getItem('senerfi_people');
        const people = peopleRaw ? JSON.parse(peopleRaw) : [];
        if (Array.isArray(people)) {
          const person = people.find(p => String(p.cedula || p.doc || '').trim() === doc);
          if (person) {
            if (!responsibleName) responsibleName = person.name || person.nombre || '';
            if (!responsibleCargo) responsibleCargo = person.role || person.cargo || person.job_title || person.jobTitle || '';
          }
        }
        
        // 2. Si aún no hay nombre, buscar en usuarios del sistema (senerfi_user_prefs)
        if (!responsibleName) {
           const prefsRaw = localStorage.getItem('senerfi_user_prefs');
           const prefs = prefsRaw ? JSON.parse(prefsRaw) : {};
           const users = Array.isArray(prefs.users) ? prefs.users : [];
           const user = users.find(u => String(u.responsibleCedula || u.responsible_cedula || u.cedula || '').trim() === doc);
           if (user) {
             responsibleName = user.name || user.nombre || '';
             if (!responsibleCargo) responsibleCargo = user.role || 'Usuario';
           }
        }
      }
    } catch (e) { }

    const nombre = responsibleName || (isEntrada ? (responsibleDoc || 'Proveedor/Origen') : '') || '';
    const cedula = responsibleDoc || '';
    const cargo = responsibleCargo;
    const observaciones = mv?.observations || '';
    // Usuario que entrega: resolver desde el movimiento (performed_by_*) o buscar en prefs
    let entregaNombre = '';
    let entregaCedula = '';
    try {
      const raw = localStorage.getItem('senerfi_user_prefs');
      const prefs = raw ? JSON.parse(raw) : {};
      const users = Array.isArray(prefs?.users) ? prefs.users : [];
      const byId = (typeof mv?.performed_by_admin_id === 'number') ? users.find(u => Number(u.id) === Number(mv.performed_by_admin_id)) : null;
      const byEmail = mv?.performed_by_email ? users.find(u => String(u.email || '').toLowerCase() === String(mv.performed_by_email).toLowerCase()) : (mv?.user ? users.find(u => String(u.email || '').toLowerCase() === String(mv.user).toLowerCase()) : null);
      const byName = mv?.performed_by_name ? users.find(u => String(u.name || '').trim().toLowerCase() === String(mv.performed_by_name).trim().toLowerCase()) : (mv?.user ? users.find(u => String(u.name || '').trim().toLowerCase() === String(mv.user).trim().toLowerCase()) : null);
      const resolvedUser = byId || byEmail || byName || null;
      entregaNombre = resolvedUser?.name || mv?.performed_by_name || mv?.user || 'Usuario';
      entregaCedula = mv?.performed_by_dni || resolvedUser?.responsibleCedula || resolvedUser?.responsible_cedula || '';

      // Fallback: si no resolvimos nada, toma el usuario actual de preferencias
      if ((!entregaNombre || entregaNombre === 'Usuario') && prefs?.currentUserId) {
        const cur = users.find(u => Number(u.id) === Number(prefs.currentUserId));
        if (cur) {
          entregaNombre = cur.name || entregaNombre;
          entregaCedula = entregaCedula || cur.responsibleCedula || cur.responsible_cedula || '';
        }
      }
    } catch (e) {
      entregaNombre = mv?.performed_by_name || mv?.user || 'Usuario';
      entregaCedula = mv?.performed_by_dni || '';
      try {
        const raw2 = localStorage.getItem('senerfi_user_prefs');
        const prefs2 = raw2 ? JSON.parse(raw2) : {};
        const users2 = Array.isArray(prefs2?.users) ? prefs2.users : [];
        if ((!entregaNombre || entregaNombre === 'Usuario') && prefs2?.currentUserId) {
          const cur2 = users2.find(u => Number(u.id) === Number(prefs2.currentUserId));
          if (cur2) {
            entregaNombre = cur2.name || entregaNombre;
            entregaCedula = entregaCedula || cur2.responsibleCedula || cur2.responsible_cedula || '';
          }
        }
      } catch (_) {}
    }

    // Ãtems: si viene un arreglo de Ã­tems en el movimiento, lo usamos.
    // En caso contrario, construimos uno con el material principal.
    const mvItemsRaw = mv?.items;
    const itemsArray = Array.isArray(mvItemsRaw) && mvItemsRaw.length > 0
      ? mvItemsRaw.map((it) => {
          const name = it?.materialName || it?.materialId || it?.desc || '';
          const code = String(it?.materialCode || '').trim();
          return {
            desc: code ? `${code} - ${name}` : name,
            serie: String(it?.serial || '').trim(),
            marca: String(it?.brandName || '').trim(),
            und: it?.materialUnit || it?.unit || it?.und || '',
            cant: it?.quantity || it?.cant || '',
            category: it?.category || it?.materialCategory || it?.material_category || ''
          };
        })
      : [{
          desc: (function(){
            const name = mv?.materialName || mv?.materialId || '';
            const code = String(mv?.materialCode || '').trim();
            return code ? `${code} - ${name}` : name;
          })(),
          serie: String(mv?.serial || '').trim(),
          marca: String(mv?.brandName || '').trim(),
          und: mv?.materialUnit || mv?.unit || '',
          cant: mv?.quantity || '',
          category: mv?.material_category || mv?.category || ''
        }];
    // Mantiene al menos 9 filas, pero si hay más, se expandirá automáticamente
    const totalItemRows = Math.max(itemsArray.length, 9);
    // Serial y Marca: toman del comprobante o del primer ítem si existe
    const serialValor = String(
      mv?.serial || (
        Array.isArray(mvItemsRaw)
          ? (mvItemsRaw.find((it) => !!it?.serial)?.serial || '')
          : ''
      )
    ).trim();
    const marcaValor = String(
      mv?.brandName || (
        Array.isArray(mvItemsRaw)
          ? (mvItemsRaw.find((it) => !!it?.brandName)?.brandName || '')
          : ''
      )
    ).trim();

    const basePath = (process.env.PUBLIC_URL || '/').replace(/\/$/, '');
    const resolvedLogo = `${basePath}${logoUrl}`;
    // Intenta incrustar el logo como Data URL para asegurar visibilidad en impresión
    let logoSrc = resolvedLogo;
    try {
      const resp = await fetch(resolvedLogo, { cache: 'no-store' });
      if (resp.ok) {
        const blob = await resp.blob();
        logoSrc = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });
      }
    } catch (e) {
      // si falla la conversión, usamos la ruta resuelta
    }
    // Usamos un iframe invisible en lugar de una ventana about:blank para asegurar misma-origen y carga fiable de assets
    const frame = document.createElement('iframe');
    frame.style.position = 'fixed';
    frame.style.right = '0';
    frame.style.bottom = '0';
    frame.style.width = '0';
    frame.style.height = '0';
    frame.style.border = '0';
    frame.name = 'PRINT';
    document.body.appendChild(frame);
    const w = frame.contentWindow;
    // Firma digital del receptor: intenta traer de mv.signatureData o localStorage por cédula
    let firmaRecibe = '';
    try {
      firmaRecibe = mv?.signatureData || '';
      if (!firmaRecibe && cedula) {
        const sigRaw = localStorage.getItem('senerfi_people_signatures');
        const sigMap = sigRaw ? JSON.parse(sigRaw) : {};
        firmaRecibe = sigMap[String(cedula)] || '';
      }
    } catch (e) {}

    // Ajuste de firmas: en devoluciones, "Entrega" es quien tenía asignado (responsable)
    // y "Recibe" es el usuario/sistema que registra la devolución.
    const entregaNombreUi = isDevolucion ? nombre : entregaNombre;
    const entregaCedulaUi = isDevolucion ? cedula : entregaCedula;
    const recibeNombreUi = isDevolucion ? (entregaNombre || 'Sistema') : nombre;
    const recibeCedulaUi = isDevolucion ? (entregaCedula || '') : cedula;

    const firmaEntregaHtml = isDevolucion
      ? (firmaRecibe
          ? `<div style="height:28px; display:flex; align-items:center; justify-content:center"><img src="${firmaRecibe}" alt="Firma" style="max-height:28px; max-width:100%; object-fit:contain" /></div>`
          : `<div style="height:28px; border-bottom:1px solid #000"></div>`)
      : `<div style="height:28px; border-bottom:1px solid #000"></div>`;

    const firmaRecibeHtml = isDevolucion
      ? `<div style="height:28px; border-bottom:1px solid #000"></div>`
      : (firmaRecibe
          ? `<div style="height:28px; display:flex; align-items:center; justify-content:center"><img src="${firmaRecibe}" alt="Firma" style="max-height:28px; max-width:100%; object-fit:contain" /></div>`
          : `<div style="height:28px; border-bottom:1px solid #000"></div>`);

    const parseBogotaDate = (raw) => {
      if (raw instanceof Date) return raw;
      if (typeof raw === 'number') return new Date(raw);
      const s = String(raw || '').trim();
      if (!s) return new Date();
      if (/^\d{4}-\d{2}-\d{2}([ T])\d{2}:\d{2}:\d{2}(?:\.\d+)?$/.test(s)) {
        const iso = s.replace(' ', 'T') + '-05:00';
        return new Date(iso);
      }
      if (/^\d{4}-\d{2}-\d{2}([ T])\d{2}:\d{2}$/.test(s)) {
        const iso = s.replace(' ', 'T') + ':00-05:00';
        return new Date(iso);
      }
      if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
        const iso = s + 'T00:00:00-05:00';
        return new Date(iso);
      }
      if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(Z|[+-]\d{2}:\d{2})$/.test(s)) {
        return new Date(s);
      }
      if (/^\d{4}\/\d{2}\/\d{2}([ T])\d{2}:\d{2}(?::\d{2})?$/.test(s)) {
        const norm = s.replace(/\//g, '-');
        const withSecs = /:\d{2}$/.test(norm) ? norm : norm + ':00';
        const iso = withSecs.replace(' ', 'T') + '-05:00';
        return new Date(iso);
      }
      const n = Number(s);
      if (!Number.isNaN(n) && Number.isFinite(n)) return new Date(n);
      return new Date(s);
    };
    const formatBogotaYmdHms = (val) => {
      const d = val instanceof Date ? val : (typeof val === 'number' ? new Date(val) : parseBogotaDate(val));
      const parts = new Intl.DateTimeFormat('es-CO', { timeZone: 'America/Bogota', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }).formatToParts(d);
      const map = Object.fromEntries(parts.map(p => [p.type, p.value]));
      return `${map.year}-${map.month}-${map.day} ${map.hour}:${map.minute}:${map.second}`;
    };
    const fechaDocumento = (function(){
      const src = mv?.created_at || mv?.date || mv?.ts;
      try { return formatBogotaYmdHms(src); } catch (_) { return formatBogotaYmdHms(new Date()); }
    })();
    const formatCode = String(qualityMeta?.code || 'FT-ALM-116').trim();
    const formatVersion = String(qualityMeta?.version || '3').trim();
    const fixedFormatDate = String(qualityMeta?.effective_date_display || '14/01/2026').trim();
    const impresionFecha = formatBogotaYmdHms(new Date());

    // Buscar categoría en el root o en el primer ítem
    const matCat = String(mv?.material_category || mv?.category || (itemsArray.length > 0 ? itemsArray[0].category : '') || '').toLowerCase();
    
    // VALIDACIÓN: Material y Herramienta = Disclaimer Corto. Dotación, Tecnología, etc = Disclaimer Largo.
    const isShortCategory = matCat.includes('material') || matCat.includes('herramienta');
    const useShortDisclaimer = isShortCategory;

    const disclaimerText = useShortDisclaimer
      ? 'Certifico que los elementos detallados en el presente documento me han sido entregados para mi cuidado y custodia, con el propósito de cumplir con las tareas y asignaciones propias de mi cargo, siendo estos mi única y exclusiva responsabilidad.'
      : 'Certifico que los elementos detallados en el presente documento me han sido entregados para mi cuidado y custodia, con el propósito de cumplir con las tareas y asignaciones propias de mi cargo, siendo estos mi única y exclusiva responsabilidad. Me comprometo a usar correctamente los recursos y solo para los fines establecidos; De igual forma me comprometo a devolver, en las mismas condiciones teniendo en cuenta la depreciación de este y con los mismos accesorios con que fue entregado, una vez mi vínculo laboral se dé por terminado, de acuerdo con la cláusula decimosegunda (12) del contrato laboral - Autorización expresa: por daño y/o maltrato de los elementos será descontado por nómina el valor del arreglo o devolución del elemento.';

    w.document.write(`<!doctype html><html><head><meta charset="utf-8" /><title>${formatCode} Comprobante ${type}</title>
      <style>
        @page { size: 210mm 297mm; margin: 10mm; }
        @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
        body{font-family: Arial, sans-serif; color:#000;}
        .sheet{width: 100%; max-width: 18.5cm; margin: 0 auto; padding: 8px; display:flex; flex-direction:column; min-height: 26.5cm;}
        table{width:100%; border-collapse:collapse; table-layout: fixed;}
        .items-table{page-break-inside:auto}
        tr{page-break-inside:avoid}
        /* Bordes estÃ¡ndar en negro de 1px (sin color) */
        td, th{border:1px solid #000; padding:6px 8px; font-size:10.5px; vertical-align:top}
        .no-border td, .no-border th{border:none}
        .header-title{font-weight:700; font-size:13px}
        .section-title{font-weight:600; background:#f7f7f7; border:1px solid #000; padding:6px 8px}
        .checkbox{height:18px}
        .small{font-size:11px}
        .center{text-align:center}
        .right{text-align:right}
        .lbl{width:120px}
        .sign{height:60px}
        .disclaimer{font-size:8.5px; color:#000; text-align:justify; line-height:1.30}
        .logo{height:52px; max-width:100%; object-fit:contain; display:block; margin:0 auto}
        .logo-box{display:flex; align-items:center; justify-content:center; height:100%}
        ul.opcionales{margin:0; padding-left:14px; font-size:10px; list-style: disc;}
        .footer{margin-top:auto}
        .version{font-size:9px; color:#555}
      </style>
    </head><body>
      <div class="sheet">
        <table>
          <tr>
            <td rowspan="3" style="width:30%; text-align:center; vertical-align:middle">
              <div class="logo-box">
                <img src="${logoSrc}" alt="Senerfi" class="logo" />
              </div>
            </td>
            <td style="width:50%" class="center header-title">SOLUCIONES ENERGETICAS FORESTALES INTEGRALES</td>
            <td style="width:20%" class="center">
              <div class="header-title">CODIGO</div>
              <div>${formatCode}</div>
            </td>
          </tr>
          <tr>
            <td class="center" style="font-weight:700">ALMACEN</td>
            <td class="center">
              <div class="header-title">VERSION</div>
              <div>${formatVersion}</div>
            </td>
          </tr>
          <tr>
            <td class="center">FORMATO GESTION DE INSUMOS</td>
            <td class="center">
              <div class="header-title">FECHA</div>
              <div>${fixedFormatDate}</div>
              <div class="version">Impresión v ${impresionFecha}</div>
            </td>
          </tr>
        </table>

        <!-- Bloque de selecciÃ³n de gestiÃ³n (izquierda) -->
        <table style="margin-top:6px">
          <tr>
            <td colspan="7" style="font-style:italic">Marque con X la gestión a realizar</td>
          </tr>
          <tr>
            <td class="center" style="text-transform:uppercase">Asignación</td>
            <td class="center" style="text-transform:uppercase">Entrada de almacén</td>
            <td class="center" style="text-transform:uppercase">Salida de almacén</td>
            <td class="center" style="text-transform:uppercase">Devolución</td>
            <td class="center" style="text-transform:uppercase">Préstamo</td>
            <td class="center" style="text-transform:uppercase">Traslado</td>
            <td class="center" style="text-transform:uppercase">Consumible</td>
          </tr>
          <tr>
            <td class="center">${isAsignacion ? 'X' : ''}</td>
            <td class="center">${isEntrada ? 'X' : ''}</td>
            <td class="center">${isSalida ? 'X' : ''}</td>
            <td class="center">${isDevolucion ? 'X' : ''}</td>
            <td class="center">${isPrestamo ? 'X' : ''}</td>
            <td class="center">${isTraslado ? 'X' : ''}</td>
            <td class="center">${isConsumible ? 'X' : ''}</td>
          </tr>
        </table>

        <!-- Bloque de Proyecto/Fecha y datos personales como la imagen -->
        <table style="margin-top:6px">
          <tr>
            <td style="width:50%; vertical-align:top; padding:8px">
              <strong>Proyecto:</strong> ${proyecto || ''}
              ${proyectoLinea2 ? `<br>${proyectoLinea2}` : ''}
            </td>
            <td style="width:50%; vertical-align:top; padding:8px">
              <strong>Fecha:</strong> ${fechaDocumento}
              ${entryRef ? `<br><strong>Consecutivo:</strong> ${entryRef}` : ''}
            </td>
          </tr>
          <tr>
            <td colspan="2"><strong>Nombre completo:</strong> ${nombre}</td>
          </tr>
          <tr>
            <td><strong>Cc:</strong> ${cedula}</td>
            <td><strong>Cargo:</strong> ${cargo}</td>
          </tr>
        </table>

                <!-- Tabla de ítems (ITEM, DESCRIPCION, SERIE, MARCA, UND, CANT) dinámica -->
        <table class="items-table" style="margin-top:6px">
          <thead>
            <tr>
              <th style="width:6%" class="center">ITEM</th>
              <th style="width:40%" class="center">DESCRIPCION</th>
              <th style="width:16%" class="center">SERIE</th>
              <th style="width:16%" class="center">MARCA</th>
              <th style="width:8%" class="center">UND</th>
              <th style="width:8%" class="center">CANT</th>
            </tr>
          </thead>
          <tbody>
            ${ itemsArray.map((row, idx) => `
              <tr>
                <td class="center">${idx + 1}</td>
                <td>${row.desc || ''}</td>
                <td>${row.serie || ''}</td>
                <td>${row.marca || ''}</td>
                <td class="center">${row.und || ''}</td>
                <td class="center">${row.cant || ''}</td>
              </tr>
            `).join('') }
            ${ Array.from({ length: totalItemRows - itemsArray.length }).map((_, i) => `
              <tr>
                <td class="center">${itemsArray.length + i + 1}</td>
                <td></td>
                <td></td>
                <td></td>
                <td class="center"></td>
                <td class="center"></td>
              </tr>
            `).join('') }
          </tbody>
        </table>
        
        ${ (isEntrada && (serialValor || marcaValor) && (totalItemRows === 1)) ? `
        <!-- Serial/Marca (solo para entradas de un ítem) -->
        <table style="margin-top:6px">
          <tr>
            <td class="section-title" style="width:18%">SERIE:</td>
            <td style="width:32%">${serialValor}</td>
            <td class="section-title" style="width:18%">MARCA:</td>
            <td style="width:32%">${marcaValor}</td>
          </tr>
        </table>
        ` : ''}

        <!-- SecciÃ³n de Observaciones -->
        <table style="margin-top:6px">
          <tr><td class="section-title">OBSERVACION:</td></tr>
          <tr><td style="height:90px">${observaciones}</td></tr>
        </table>

        <div class="disclaimer" style="margin-top:6px; border-top:1px solid #000; padding-top:6px">
            ${disclaimerText}
        </div>

        <div class="footer">
          <table style="margin-top:6px">
            <tr><td class="section-title">FIRMAS:</td></tr>
          </table>
          <table style="margin-top:2px; width:100%">
            <tr>
              <td style="width:50%; padding:8px; border:1px solid #000">
                <div>Entrega:</div>
                ${firmaEntregaHtml}
                <div class="small center" style="margin-top:4px">${entregaNombreUi}${entregaCedulaUi ? ' (' + entregaCedulaUi + ')' : ''}</div>
              </td>
              <td style="width:50%; padding:8px; border:1px solid #000">
                <div>Recibe:</div>
                ${firmaRecibeHtml}
                <div class="small center" style="margin-top:4px">${recibeNombreUi}${recibeCedulaUi ? ' (' + recibeCedulaUi + ')' : ''}</div>
              </td>
            </tr>
          </table>
          <table style="margin-top:6px; width:100%">
            <tr>
              <td class="right"><span class="small">Consecutivo: ${formatRef}</span></td>
            </tr>
          </table>
        </div>
      </div>
      <script>
        // Espera la carga del logo y aplica fallback desde /Senerfi-formato.png si falla
        window.addEventListener('load', function() {
          const img = document.querySelector('.logo');
          const fallbackSrc = '${basePath}/Senerfi-formato.png';
          const printNow = () => { window.focus(); window.print(); setTimeout(() => window.close(), 300); };

          if (!img) { printNow(); return; }

          // Si ya cargÃ³ correctamente
          if (img.complete && img.naturalWidth > 0) { printNow(); return; }

          // Al cargar exitosamente, imprime
          img.addEventListener('load', printNow, { once: true });

          // Si falla, intenta una vez con el recurso pÃºblico
          img.addEventListener('error', function onErr() {
            if (img.src !== fallbackSrc) {
              img.src = fallbackSrc;
              img.addEventListener('load', printNow, { once: true });
              img.addEventListener('error', printNow, { once: true });
            } else {
              printNow();
            }
          }, { once: true });

          // ImpresiÃ³n defensiva por si eventos no disparan
          setTimeout(() => {
            if (img.complete && img.naturalWidth > 0) { printNow(); }
          }, 1200);
        });
      </script>
    </body></html>`);
    w.document.close();
    w.focus();
    // Fallback defensivo: intenta imprimir desde el contexto del iframe si por alguna razón el script interno no dispara
    try {
      setTimeout(() => {
        try { w.print(); } catch (_) {}
      }, 800);
    } catch (_) {}
    // La impresión se dispara desde el script interno cuando el logo está listo; luego removemos el iframe
    frame.onload = () => {
      // Por si el evento load del documento no dispara, aseguramos limpieza post-impresiÃ³n
      setTimeout(() => {
        try {
          if (frame && frame.parentNode) {
            frame.parentNode.removeChild(frame);
          } else if (typeof frame.remove === 'function') {
            frame.remove();
          }
        } catch (_) {}
      }, 1500);
    };
  } catch (e) {
    console.error('Error printing movement', e);
    alert('No se pudo generar el comprobante.');
  }
}




